<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div class="modal-body">
  <p class="text-center mb-30">
    Nesta etapa precisamos
    <strong
      >enviar um token de segurança ao cliente para confirmar se este é o seu
      celular pessoal</strong
    >, permitindo realizar a Assinatura Digital e ser contatado para qualquer
    fim no futuro.
  </p>

  <form class="token" *ngIf="solicitou">
    <label class="font-size">Digite o Token do Cliente</label>
    <div class="input-token">
      <div
        [formGroup]="tokenForm"
        [ngClass]="{
          'has-error': tokenStatusAtual === tokenStatus.FAIL,
          sent: tokenStatusAtual === tokenStatus.SENT,
          success: tokenStatusAtual === tokenStatus.SUCCESS
        }"
      >
        <input
          class="form-control text-token"
          type="text"
          placeholder="0 0 0 0 0 0"
          [minLength]="6"
          [maxLength]="6"
          name="codigoConfirmacao"
          formControlName="codigoConfirmacao"
          appOnlyDigitsLengthValidator
          appOnlyNumberRestrictive
          autocomplete="off"
        />
        <div
          *ngIf="tokenStatusAtual === tokenStatus.FAIL"
          class="msg-token text-danger"
        >
          <span class="fa fa-ban"></span>
          Token inválido
        </div>

        <div
          *ngIf="tokenStatusAtual === tokenStatus.SENT"
          class="msg-token text-blue"
        >
          <span class="icon token-enviado"></span>
          Token enviado
        </div>

        <div
          *ngIf="tokenStatusAtual === tokenStatus.SUCCESS"
          class="msg-token text-success"
        >
          <img
            src="assets/images/icons/icon-green-check.png"
            width="20"
            alt="gerar relatório"
            class="mr-10"
          />
          Token validado
        </div>
      </div>

      <div
        class="centered flex-column"
        *ngIf="tokenStatusAtual !== tokenStatus.SUCCESS"
      >
        <button
          class="btn btn-border-orange"
          (click)="solicitarToken()"
          *ngIf="!enviado"
        >
          <span class="fa fa-envelope"></span>
          Reenviar Token
        </button>

        <button
          class="btn btn-border-orange"
          *ngIf="enviado"
          [ngClass]="{ disabled: enviado }"
        >
          <span class="fa fa-envelope"></span>
          Reenviar em {{ timeLeft }}s
        </button>

        <a (click)="abrirModalDeInformacao()" class="text-center text-highlight"
          >O cliente não recebeu o token?</a
        >
      </div>
    </div>
  </form>

  <div *ngIf="tokenStatusAtual !== this.tokenStatus.SUCCESS" class="centered mb-0 mt-30">
    <span class="icon warning icone-laranja"></span>
    <p class="text-left mb-0">
      <strong class="text-orange">ATENÇÃO:</strong> Se o celular do cliente não
      for validado,
      <strong class="text-danger"
        >não será permitida a utilização da assinatura digital do
        contrato!</strong
      >
    </p>
  </div>
</div>

<div class="modal-footer" [ngClass]="{ space: !solicitou }">
  <button
    *ngIf="!solicitou"
    type="button"
    class="btn btn-full-orange"
    (click)="solicitarToken()"
  >
    Enviar Token para celular
  </button>

  <button
    type="button"
    *ngIf="tokenStatusAtual !== this.tokenStatus.SUCCESS"
    class="btn btn-border-orange"
    (click)="onCancel.emit()"
  >
    Continuar sem validar celular
  </button>

  <button
    type="button"
    *ngIf="tokenStatusAtual === this.tokenStatus.SUCCESS"
    class="btn btn-full-orange btn-success"
    (click)="continuar()"
  >
    Continuar
    <img
      src="assets/images/icons/arrow-right.png"
      width="24"
      alt="gerar relatório"
    />
  </button>
</div>
